import React, { useEffect, useState } from "react";
import "./Contact_Us_Form.css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import {
  faLocationDot,
  faMapLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Orange_Btn from "../../common/common_btn/orange_btn/Orange_Btn";
import Successfull_Modal from "../../common/modals/common-modal/successfull_modal/Successfull_Modal";
import { AllCenters, AllCountry } from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Create } from "../../../features/admin/contactus/contact/Slice";
import { AllSocialLink } from "../../../features/admin/footer/Slice";
import { Link } from "react-router-dom";

const Contact_Us_Form = () => {
  const [showBg, setShowBg] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [hideContent, setHideContent] = useState(false);
  const [slideBack, setSlideBack] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [location, setLocation] = useState(false);

  const handleMapTextClick = () => {
    setShowForm(true);
    setShowBg(true);
  };

  const {
    control,
    reset,
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const all_centers = useSelector((state) => state.common.all_centers);
  const countries = useSelector((state) => state.common.all_country);
  const all_social_links = useSelector(
    (state) => state.footer.all_social_links,
  );

  const submitForm = async (data) => {
    const sendData = new FormData();
    sendData.append("name", data?.name);
    sendData.append("email", data?.email);
    sendData.append("number", data?.number);
    sendData.append("message", data?.message);
    sendData.append("country_id", data?.country_id?.value);

    const res = await dispatch(Create(sendData));
    if (res.meta?.requestStatus === "fulfilled") {
      reset();
      setValue("name", "");
      setValue("email", "");
      setValue("message", "");
      setValue("country_id", "");
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
      // reset();
      // setValue("name", "")
      // setValue("email", "")
      // setValue("message", "")
      // setValue("country_id", "")
    }
  };

  useEffect(() => {
    dispatch(AllCenters());
    dispatch(AllCountry());
    dispatch(AllSocialLink());
  }, [dispatch]);

  const formatFullAddress = (center, fallback) => {
    if (!center) return fallback;

    return [
      center.address,
      center.Area?.name,
      center.City?.name,
      center.State?.name,
      center.Country?.name,
      center.Pincode?.name && `- ${center.Pincode.name}`,
    ]
      .filter(Boolean)
      .join(", ");
  };

  // const contactData = [
  //   {
  //     addressCountry: "/assets/images/contact_us/img1.png",
  //     innerData: [
  //       {
  //         icon: faPhone,
  //         label: `+${all_centers[0]?.contact_no1}` || "+91 9876543210",
  //       },
  //       {
  //         icon: faWhatsapp,
  //         label: `+${all_centers[0]?.contact_no2}` || "+91 9876543210",
  //       },
  //       {
  //         icon: faLocationDot,
  //         label: formatFullAddress(all_centers[0]?.address) || "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist., Ankleshwar, Gujarat 393002 India",
  //       },
  //       {
  //         icon: faMapLocationDot,
  //         label: "Find Us on Map",
  //         link: true,
  //       },
  //     ],
  //   },
  //   {
  //     addressCountry: "/assets/images/contact_us/img2.png",
  //     innerData: [
  //       {
  //         icon: faPhone,
  //         label: `+${all_centers[1]?.contact_no1}` || "+1 9876543210",
  //       },
  //       {
  //         icon: faWhatsapp,
  //         label: `+${all_centers[1]?.contact_no2}` || "+1 9876543210",
  //       },
  //       {
  //         icon: faLocationDot,
  //         label: formatFullAddress(all_centers[1]?.address) || "1313 Springvale Dr, Belair , MD 21015, USA",
  //       },
  //       {
  //         icon: faMapLocationDot,
  //         label: "Find Us on Map",
  //         link: true,
  //       },
  //     ],
  //   },
  // ];

  const contactData = all_centers?.map((center) => ({
    addressCountry: "/assets/images/contact_us/img1.png", // keep as-is or dynamic later
    innerData: [
      {
        icon: faPhone,
        label: center?.contact_no1
          ? `+${center.contact_no1}`
          : "Contact not available",
      },
      {
        icon: faWhatsapp,
        label: center?.contact_no2
          ? `+${center.contact_no2}`
          : "Contact not available",
      },
      {
        icon: faLocationDot,
        label: formatFullAddress(center),
      },
      {
        icon: faMapLocationDot,
        label: "Find Us on Map",
        link: true,
      },
    ],
  }));

  const socialIconMap = {
    facebook: faFacebookF,
    linkedin: faLinkedinIn,
    twitter: faTwitter,
    youtube: faYoutube,
    instagram: faInstagram,
  };

  const combinedSocialLinks = all_social_links.map((item) => ({
    ...item,
    icon: socialIconMap[item.name.toLowerCase()] || null,
  }));

  const handleClose = () => {
    // setSlideBack(true);
    setShowForm(false);
    setHideContent(false);
    setShowBg(false);
    setTimeout(() => {
      setSlideBack(false);
    }, 600);
  };

  // console.log({ location });

  return (
    <section className="Contact_Us_Form">
      <div className="map_section">
        <div className="mapouter">
          <div className="gmap_canvas">
            <iframe
              className={`gmap_iframe ${showBg ? "show" : "hidden"}`}
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src={`https://maps.google.com/maps?q=${encodeURIComponent(
                location,
              )}&z=15&output=embed`}
              // src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=pune&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            ></iframe>
            <a href="https://pdflist.com/" alt="pdflist.com"></a>
          </div>
        </div>

        {hideContent && (
          <div className="close_icon_div" onClick={handleClose}>
            <img
              src="/assets/images/contact_us/close.png"
              className="close_img"
            />
          </div>
        )}
      </div>

      {/* <div className="contact_form_holder "> */}
      <div className={`contact_form_holder ${showBg ? "contact_form_bg" : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              {!hideContent && (
                <div
                  className={`left_side_part ${
                    showForm ? "slide-out-left" : "slide-in-left"
                  }`}
                  onAnimationEnd={() => {
                    if (showForm && !slideBack) setHideContent(true);
                  }}
                >
                  <Common_Title_1 subText="Contact Us" />

                  <div className="gray_box_holders">
                    {all_centers.length !== 0 &&
                      contactData?.slice(0, 2)?.map((item) => {
                        return (
                          <div
                            className="gray_contact_box"
                            onClick={() =>
                              setLocation(item?.innerData?.[2]?.label)
                            }
                          >
                            {/* <div className="contry_div">
                            <img
                              src={item?.addressCountry}
                              className="contry_img"
                            />
                          </div> */}

                            <div className="data_holder">
                              {item?.innerData?.map((innerItem) => {
                                return (
                                  <div className="record_div">
                                    <div className="icon_holder">
                                      <FontAwesomeIcon
                                        icon={innerItem?.icon}
                                        className="inner_icon"
                                      />
                                    </div>
                                    <p
                                      onClick={() =>
                                        innerItem?.link
                                          ? handleMapTextClick()
                                          : null
                                      }
                                      className={`${
                                        innerItem?.link ? "link_text " : ""
                                      }label_text`}
                                    >
                                      {innerItem?.label}
                                    </p>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                  </div>

                  <div className="divider_line"></div>

                  <div className="social_icons_div">
                    {combinedSocialLinks?.map((item) => {
                      return (
                        <Link key={item.id} to={item.url} target="_blank">
                          <div className="icon_div">
                            <FontAwesomeIcon
                              icon={item?.icon}
                              className="social_icon"
                            />
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-8">
              {!hideContent && (
                <div
                  className={`right_side ${
                    showForm ? "slide-out-right" : "slide-in-right"
                  }`}
                  onAnimationEnd={() => {
                    if (showForm && !slideBack) setHideContent(true); // Only hide if sliding OUT
                  }}
                >
                  <div className="white_card">
                    <div className="row">
                      <div className="col-12 mb-4">
                        <Form.Group className="gray_input_group">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder="Enter Name"
                            {...register("name", {
                              required: "Full name is required",
                              minLength: {
                                value: 3,
                                message: "Name must be at least 3 characters",
                              },
                              maxLength: {
                                value: 50,
                                message: "Name cannot exceed 50 characters",
                              },
                              pattern: {
                                value: /^[A-Za-z\s]+$/,
                                message:
                                  "Name can only contain letters and spaces",
                              },
                            })}
                          />
                        </Form.Group>
                        {errors?.name && (
                          <Form.Text className="text-danger">
                            {errors.name.message}
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-12 mb-4">
                        <Form.Group className="gray_input_group">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter Email"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                                message: "Enter a valid email address",
                              },
                            })}
                          />
                        </Form.Group>
                        {errors?.email && (
                          <Form.Text className="text-danger">
                            {errors.email.message}
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-6 mb-4">
                        <Form.Group className="gray_input_group">
                          <Form.Label>Contact</Form.Label>

                          <Form.Control
                            placeholder="Contact Number"
                            type="text"
                            name="number"
                            maxLength={10} // restrict typing to 10 digits
                            {...register("number", {
                              required: "Contact Number is required",
                              pattern: {
                                value: /^[0-9]+$/, // only numbers
                                message: "Only digits are allowed",
                              },
                              minLength: {
                                value: 10,
                                message:
                                  "Contact Number must be exactly 10 digits",
                              },
                              maxLength: {
                                value: 10,
                                message:
                                  "Contact Number must be exactly 10 digits",
                              },
                            })}
                          />
                        </Form.Group>
                        {errors?.number && (
                          <Form.Text className="text-danger">
                            {errors.number.message}
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-sm-6 mb-4">
                        <Form.Group className="gray_input_group">
                          <Form.Label>Country of Residence</Form.Label>

                          <Controller
                            className="Select_Dropdown_holder"
                            name="country_id"
                            control={control}
                            rules={{ required: "Country is required" }}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.country_id
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                                {...field}
                                options={countries}
                              />
                            )}
                          />
                        </Form.Group>
                        {errors?.country_id && (
                          <Form.Text className="text-danger">
                            {errors.country_id.message}
                          </Form.Text>
                        )}
                      </div>

                      <div className="col-12 mb-4">
                        <Form.Group className="gray_input_group">
                          <Form.Control
                            type="text"
                            as={"textarea"}
                            name="message"
                            placeholder="Enter Massage"
                            {...register("message", {
                              required: "Message is required",
                            })}
                          />
                        </Form.Group>
                        {errors?.message && (
                          <Form.Text className="text-danger">
                            {errors.message.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="btn_holder">
                    <Orange_Btn
                      btnText={"Sumbit"}
                      onClick={handleSubmit(submitForm)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Successfull_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        headtext={"Message Sent!"}
        successfultext={"Message Sent Successfully!"}
        subtext={"See You Soon!"}
        subtext2={"Have a nice time ahead!"}
      />
    </section>
  );
};

export default Contact_Us_Form;
